import { FormArray } from '@angular/forms';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-pos-documents-step-modal',
  templateUrl: './pos-documents-step-modal.component.html',
  styleUrls: ['./pos-documents-step-modal.component.sass'],
})
export class PosDocumentsStepModalComponent implements OnInit {
  @Input()
  documentsForm: FormArray = new FormArray([]);

  @Output() attachmentFilesChange: EventEmitter<any> = new EventEmitter();

  constructor(public bsModalRef: BsModalRef) {}

  ngOnInit(): void {}

  close() {
    this.bsModalRef.hide();
  }

  confirm() {
    this.attachmentFilesChange.emit({
      documentsFormValue: this.documentsForm.value,
    });
    this.attachmentFilesChange.complete();
    this.close();
  }
}
